import { combineReducers } from 'redux';

import {
	FETCH_DATA_REQUEST,
	FETCH_DATA_SUCCESS,
	FETCH_DATA_FAILURE,
	VIEWED_NOTIFICATION,
	TOGGLE_NOTIFICATION,
	LOGOUT_USER,
} from '../types';

const setNotificaitonToViewed = (state, action) => {
	const id = action.payload;
	const notification = state[id];

	return {
		...state,
		[id] : {
			...notification,
			'viewed': true,
		}
	}
}

const toggleNotification = (state, action) => {
	console.log('here I am')
	const id = action.payload;
	const notification = state[id];

	return {
		...state,
		[id] : {
			...notification,
			'collapsed': !notification.collapsed
		}
	}
}

const byId = (state = {}, action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return {
				...state,
				...action.payload.notifications.entities.notifications,
			}
		
		case VIEWED_NOTIFICATION:
			return setNotificaitonToViewed(state, action);

		case TOGGLE_NOTIFICATION:
			return toggleNotification(state, action);

		case LOGOUT_USER:
			return {}

		default:
			return state;
	}
}

const allIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return action.payload.notifications.result;

		case LOGOUT_USER:
			return []
		
		default:
			return state;
	}
}

const isFetching = (state = false, action) => {
	switch (action.type) {
		case FETCH_DATA_REQUEST:
			return true;

		case FETCH_DATA_SUCCESS:
		case FETCH_DATA_FAILURE:
		case LOGOUT_USER:
			return false;

		default:
			return state;
	}
}

const errorMessage = (state = null, action) => {
	switch (action.type) {
		case FETCH_DATA_FAILURE:
			return action.payload;

		case FETCH_DATA_REQUEST:
		case FETCH_DATA_SUCCESS:
		case LOGOUT_USER:
			return null;

		default:
			return state;
	}
}


const files = combineReducers({
	byId,
	allIds,
	isFetching,
	errorMessage,
});
export default files;

export const getIsFetching = (state) => state.isFetching;
export const getIds = (state) => state.allIds;

export const getNotifications = (state) => {
	const ids = getIds(state);
	return ids.map(id => state.byId[id]);
}

export const getNewNotifications = state => {
	const ids = getIds(state);
	return ids.filter(id => !state.byId[id].viewed).map(id => state.byId[id]);
}


// WEBPACK FOOTER //
// ./src/store/notifications/reducer.js